import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-6 col-md-2" }
const _hoisted_5 = { class: "col-6 col-md-2" }
const _hoisted_6 = {
  key: 0,
  class: "col-6 col-md-2"
}
const _hoisted_7 = { class: "col-6 col-md-2" }
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "col-6 col-md-2" }
const _hoisted_10 = ["value"]
const _hoisted_11 = { class: "col-6 col-md-2" }
const _hoisted_12 = { class: "row mt-2" }
const _hoisted_13 = { class: "col-md-12 table-responsive" }
const _hoisted_14 = { class: "table align-middle mb-0 table-hover" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "nowrap-celular" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { class: "nowrap-celular" }
const _hoisted_19 = { class: "nowrap-celular" }
const _hoisted_20 = { class: "text-center text-nowrap" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "card-footer" }
const _hoisted_25 = { class: "row mt-2" }
const _hoisted_26 = { class: "col-md-4" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "col-md-2" }

import { defineComponent, onMounted, reactive } from "vue";

  import BreadCrumb from "../../components/Common/BreadCrumb.vue";

  //servicos
  import * as service from "@/services/clientesService";
  import { setaFocus} from "@/utils/funcoes";
  import config from "@/app.config.json";
  
  //componentes
  import Paginador from "@/components/Paginador/Index.vue";
  import DropdownCidadesAtiva from "@/components/Dropdowns/DropdownCidadesAtiva.vue";
  import DropdownVendedores from "@/components/Dropdowns/DropdownVendedores.vue";
  import MsgBox from "@/components/MsgBox/Index.vue";
  
  import { useUserStore } from "@/stores/userStore";

  import { useAcl } from "vue-simple-acl";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'Index',
  setup(__props) {

  const acl = useAcl();

  const userStore = useUserStore();

  var controle = reactive({
    filtros: {
      comCidades: true,
      ativo: null,
      vendedorId: null,
      paginaAtual: 1,
      tamanhoPagina: 10
    } as unknown as service.Filtros,
    itens: [] as service.Cliente[],
    totalRegistros: 0,

    tipos: ['- Todos -','Particular','Empresarial'] ,
    listaStatus:[
      {valor: null, descricao:"- Todos -"},
      {valor: true, descricao:"Ativos"},
      {valor: false, descricao:"Inativos"},
    ],
    listaCortesia:[
      {valor: null, descricao:"Todos"},
      {valor: true, descricao:"Com Cortesia"},
      {valor: false, descricao:"Sem Cortesia"},
    ],

    itemExcluir: null as service.Cliente | null,
    janExcluir: false,
    status: "",
    erro: "",

    ordenacao: {
      coluna: '',
      asc: true
    },
  })

  onMounted(async ()=>{
    setaFocus("txtPesquisar");
    pesquisar();
  })

  async function pesquisar() {

    if (acl.can("vendedor") && !acl.can("supervisor")) {
      controle.filtros.usuarioId = userStore.user?.usuarioId  || null;
    }

    service.obter(controle.filtros)
    .then(r=> {
      controle.itens = r.dados;
      controle.totalRegistros = r.totalRegistros;
    })
    .catch(erro=> {
      controle.erro = erro;
    })
  }

  function ordenarPor(coluna: string) {
    if (controle.ordenacao.coluna === coluna) {
      controle.ordenacao.asc = !controle.ordenacao.asc;
    } else {
      controle.ordenacao.coluna = coluna;
      controle.ordenacao.asc = true;
    }
    
    controle.itens?.sort((a, b) => {
      let valA = (a as Record<string, any>)[coluna];
      let valB = (b as Record<string, any>)[coluna];
      if (typeof valA === 'string') valA = valA.toLowerCase();
      if (typeof valB === 'string') valB = valB.toLowerCase();
      if (valA < valB) return controle.ordenacao.asc ? -1 : 1;
      if (valA > valB) return controle.ordenacao.asc ? 1 : -1;
      return 0;
    });
  }

  
  function pergExcluir(item: service.Cliente) {
    controle.janExcluir = true;
    controle.itemExcluir = item;
  }

  function excluir() {
    if (controle.itemExcluir) {
      service.excluir(controle.itemExcluir.clienteId)
        .then(() => {
          controle.janExcluir = false;
          pesquisar();
        })
        .catch(erro => {
          controle.erro = erro;
          controle.janExcluir = false;
        });
    }
  }

function painelCliente(item: service.Cliente) {
    service.gerarSenhaTemporaria({clienteId: item.clienteId, minutos: 1440})
      .then(senha => {
        
        window.open(`${config.urlPainelCliente}/Cliente/LoginExterno?clienteId=${item.clienteId}&senha=${senha}`, '_blank');
      })
      .catch(erro => {
        controle.erro = erro;
      });
  }

  async function copiarLink(item: service.Cliente) {
    try {
      var r = await  service.gerarSenhaTemporaria({clienteId: item.clienteId, minutos: 1440});

      var link = `${config.urlPainelCliente}/Cliente/LoginExterno?clienteId=${item.clienteId}&senha=${r}`;

      await navigator.clipboard.writeText(link);
      alert("Link copiado para a área de transferência!");
      controle.status = "Link copiado para a área de transferência!";
    } catch (erro:  any) {
      controle.erro = erro;
    }
    
  }

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _directive_can = _resolveDirective("can")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BreadCrumb, { PageTitle: "Clientes" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[15] || (_cache[15] = _createElementVNode("label", null, [
              _createElementVNode("i", { class: "flaticon-search" }),
              _createTextVNode(" Pesquisar")
            ], -1)),
            _withDirectives(_createElementVNode("input", {
              type: "text",
              class: "form-control form-control-sm",
              placeholder: "Nome, código...",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(controle).filtros.nome) = $event)),
              onKeyup: pesquisar,
              id: "txtPesquisar"
            }, null, 544), [
              [_vModelText, _unref(controle).filtros.nome]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _cache[16] || (_cache[16] = _createElementVNode("label", null, "Cidade", -1)),
            _createVNode(DropdownCidadesAtiva, {
              modelValue: _unref(controle).filtros.cidadeId,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(controle).filtros.cidadeId) = $event)),
              onChange: pesquisar
            }, null, 8, ["modelValue"])
          ]),
          (_unref(acl).can('supervisor') || _unref(acl).can('admin'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _cache[17] || (_cache[17] = _createElementVNode("label", null, "Vendedor", -1)),
                _createVNode(DropdownVendedores, {
                  modelValue: _unref(controle).filtros.usuarioId,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(controle).filtros.usuarioId) = $event)),
                  onChange: pesquisar
                }, null, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _cache[18] || (_cache[18] = _createElementVNode("label", null, "Cortesia", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(controle).filtros.cortesia) = $event)),
              onChange: pesquisar
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).listaCortesia, (item, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.valor,
                  key: idx
                }, _toDisplayString(item.descricao), 9, _hoisted_8))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(controle).filtros.cortesia]
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _cache[19] || (_cache[19] = _createElementVNode("label", null, "Status 2", -1)),
            _withDirectives(_createElementVNode("select", {
              class: "form-select form-select-sm",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(controle).filtros.ativo) = $event)),
              onChange: pesquisar
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).listaStatus, (item, idx) => {
                return (_openBlock(), _createElementBlock("option", {
                  value: item.valor,
                  key: idx
                }, _toDisplayString(item.descricao), 9, _hoisted_10))
              }), 128))
            ], 544), [
              [_vModelSelect, _unref(controle).filtros.ativo]
            ])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-primary btn-sm mt-4 float-end",
              to: '/clientes/cadastro'
            }, {
              default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                _createElementVNode("i", { class: "flaticon-plus" }, null, -1),
                _createTextVNode(" Adicionar", -1)
              ]))]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("table", _hoisted_14, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", null, [
                  _createElementVNode("th", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (ordenarPor('usuarioId'))),
                    class: "th-sortable"
                  }, "Id"),
                  _createElementVNode("th", {
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (ordenarPor('nomeCompleto'))),
                    class: "th-sortable"
                  }, "Nome"),
                  _createElementVNode("th", {
                    onClick: _cache[7] || (_cache[7] = ($event: any) => (ordenarPor('tipoId'))),
                    class: "th-sortable"
                  }, "CPF"),
                  _createElementVNode("th", {
                    onClick: _cache[8] || (_cache[8] = ($event: any) => (ordenarPor('email'))),
                    class: "th-sortable"
                  }, "Telefone"),
                  _createElementVNode("th", {
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (ordenarPor('ativo'))),
                    class: "th-sortable"
                  }, "Celular"),
                  _createElementVNode("th", {
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (ordenarPor('ativo'))),
                    class: "th-sortable"
                  }, "Cidade"),
                  _createElementVNode("th", {
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (ordenarPor('ativo'))),
                    class: "th-sortable"
                  }, "Status"),
                  _cache[21] || (_cache[21] = _createElementVNode("th", null, "Opções", -1))
                ])
              ]),
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(controle).itens, (item, idx) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: idx,
                    class: "align-middle"
                  }, [
                    _createElementVNode("td", null, [
                      _createElementVNode("a", {
                        href: "javascript:void(0);",
                        onClick: ($event: any) => (painelCliente(item)),
                        title: "Abrir painel do cliente",
                        class: "fw-bold text-primary"
                      }, _toDisplayString(item.clienteId), 9, _hoisted_15)
                    ]),
                    _createElementVNode("td", _hoisted_16, [
                      _createTextVNode(_toDisplayString(item.nome) + " ", 1),
                      (item.cortesia == true)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_17, [...(_cache[22] || (_cache[22] = [
                            _createElementVNode("i", {
                              class: "text-primary flaticon-star-1 ms-1",
                              title: "Cortesia"
                            }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.cpf), 1),
                    _createElementVNode("td", _hoisted_18, _toDisplayString(item.telefone), 1),
                    _createElementVNode("td", _hoisted_19, _toDisplayString(item.celular), 1),
                    _createElementVNode("td", null, _toDisplayString(item.cidade?.nome), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge rounded-pill", item.ativo ? 'badge-soft-success' : 'badge-soft-danger'])
                      }, _toDisplayString(item.ativo ? 'Ativo' : 'Inativo'), 3)
                    ]),
                    _createElementVNode("td", _hoisted_20, [
                      _createElementVNode("span", null, [
                        _createElementVNode("a", {
                          class: "",
                          href: "javascript:void(0);",
                          title: "Acessar painel do cliente",
                          onClick: ($event: any) => (painelCliente(item))
                        }, [...(_cache[23] || (_cache[23] = [
                          _createElementVNode("i", { class: "flaticon-user fs-5" }, null, -1)
                        ]))], 8, _hoisted_21),
                        _createElementVNode("a", {
                          class: "ms-2",
                          href: "javascript:void(0);",
                          title: "Copiar link do painel do cliente",
                          onClick: ($event: any) => (copiarLink(item))
                        }, [...(_cache[24] || (_cache[24] = [
                          _createElementVNode("i", { class: "fa fa-copy fs-5" }, null, -1)
                        ]))], 8, _hoisted_22),
                        _createVNode(_component_RouterLink, {
                          to: '/clientes/cadastro/' + item.clienteId,
                          title: "Alterar",
                          class: "ms-2"
                        }, {
                          default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                            _createElementVNode("i", { class: "flaticon-pen fs-5" }, null, -1)
                          ]))]),
                          _: 1
                        }, 8, ["to"]),
                        (item.permCartao)
                          ? _withDirectives((_openBlock(), _createBlock(_component_RouterLink, {
                              key: 0,
                              to: `/clientes/cartao/${item.clienteId}`,
                              title: "Cartão"
                            }, {
                              default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                                _createElementVNode("i", { class: "flaticon-card fs-5 ms-2 me-2 text-dark" }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["to"])), [
                              [_directive_can, 'supervisor']
                            ])
                          : _createCommentVNode("", true),
                        _withDirectives((_openBlock(), _createElementBlock("a", {
                          class: "ms-2",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (pergExcluir(item)),
                          title: "Excluir"
                        }, [...(_cache[27] || (_cache[27] = [
                          _createElementVNode("i", { class: "flaticon-delete fs-5 text-danger" }, null, -1)
                        ]))], 8, _hoisted_23)), [
                          [_directive_can, 'supervisor']
                        ])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(controle).totalRegistros) + " Registros ", 1),
          _createElementVNode("div", _hoisted_27, [
            _createVNode(Paginador, {
              class: "float-end",
              paginaAtual: _unref(controle).filtros.paginaAtual,
              tamanhoPagina: _unref(controle).filtros.tamanhoPagina,
              totalRegistros: _unref(controle).totalRegistros,
              onOnChange: _cache[12] || (_cache[12] = (el) => { 
              _unref(controle).filtros.paginaAtual = el.paginaAtual; 
              _unref(controle).filtros.tamanhoPagina = el.tamanhoPagina;
              pesquisar() })
            }, null, 8, ["paginaAtual", "tamanhoPagina", "totalRegistros"])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_RouterLink, {
              class: "btn btn-secondary btn-sm float-end",
              to: '/'
            }, {
              default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
                _createTextVNode("Fechar", -1)
              ]))]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(MsgBox, {
      id: 'janExcluir',
      titulo: 'Atenção',
      exibir: _unref(controle).janExcluir,
      onOnFechou: _cache[13] || (_cache[13] = ($event: any) => (_unref(controle).janExcluir = false)),
      "botao-sim": true,
      "botao-nao": true,
      onOnSim: _cache[14] || (_cache[14] = ($event: any) => (excluir()))
    }, {
      default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-md-12 fw-bold fs-6" }, " Deseja excluir este registro? ")
        ], -1)
      ]))]),
      _: 1
    }, 8, ["exibir"])
  ], 64))
}
}

})